import { formatMoney } from '@betterment/js-runtime';
import { Box, ListRow, Separator, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { LegalAccountTaxationType } from '../../../../graphql/schema';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { CoordinatedAccountsCardQuery } from '../graphql/coordinatedAccountsCard.generated';

type ManagedAccount = Extract<CoordinatedAccountsCardQuery['account'], { __typename: 'ManagedAccount' }>;

type ManagedSubAccount = ManagedAccount['subAccounts'][number];

type Props = {
  subAccount: ManagedSubAccount;
};

function rowLink(taxationType: LegalAccountTaxationType, subAccountId: number) {
  switch (taxationType) {
    case LegalAccountTaxationType.TraditionalIra:
      return (
        <SambaAutoLink to={urlBuilder.appConvertFundsToRoth.absolute({ subAccountId })}>Convert to Roth</SambaAutoLink>
      );
    case LegalAccountTaxationType.RothIra:
      return (
        <SambaAutoLink to={urlBuilder.getIraRecharacterization.absolute()}>Recharacterize contribution</SambaAutoLink>
      );
    default:
      return null;
  }
}

export const CoordinatedAccountRow: React.FC<Props> = ({ subAccount }) => {
  return (
    <Box>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <ListRow css={{ color: 'text' }}>
        <ListRow.LeadingAsset>
          <Box css={{ width: '36px', height: '36px' }}>
            <ThemedImage themedAsset={subAccount.icon} alt="" />
          </Box>
        </ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          <Text>{subAccount.name}</Text>
        </ListRow.LeadingContent>
        {subAccount.balance && (
          <ListRow.TrailingContent>
            <Text>{formatMoney(subAccount.balance)}</Text>
            {rowLink(subAccount.legalAccount.taxationType, subAccount.legacySubAccountId)}
          </ListRow.TrailingContent>
        )}
      </ListRow>
    </Box>
  );
};
